/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createSpeciesDtoFromDiscriminatorValue, type SpeciesDto } from '../../../../models/index.js';
// @ts-ignore
import { createODataErrorFromDiscriminatorValue, type ODataError } from '../../../../models/oDataErrors/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Provides operations to manage the species property of the AapService.GenusDto entity.
 */
export interface WithSpeciesItemRequestBuilder extends BaseRequestBuilder<WithSpeciesItemRequestBuilder> {
    /**
     * Get species from GenusOverview
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<SpeciesDto>}
     * @throws {ODataError} error when the service returns a 4XX or 5XX status code
     */
     get(requestConfiguration?: RequestConfiguration<WithSpeciesItemRequestBuilderGetQueryParameters> | undefined) : Promise<SpeciesDto | undefined>;
    /**
     * Get species from GenusOverview
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<WithSpeciesItemRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Get species from GenusOverview
 */
export interface WithSpeciesItemRequestBuilderGetQueryParameters {
    /**
     * Expand related entities
     */
    expand?: string[];
    /**
     * Select properties to be returned
     */
    select?: string[];
}
/**
 * Uri template for the request builder.
 */
export const WithSpeciesItemRequestBuilderUriTemplate = "{+baseurl}/GenusOverview/{genusId}/species/{speciesId}{?%24expand,%24select}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const WithSpeciesItemRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "expand": "%24expand",
    "select": "%24select",
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithSpeciesItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: WithSpeciesItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            XXX: createODataErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createSpeciesDtoFromDiscriminatorValue,
        queryParametersMapper: WithSpeciesItemRequestBuilderGetQueryParametersMapper,
    },
};
/* tslint:enable */
/* eslint-enable */
